import { createReducer, on } from '@ngrx/store';

import { ZenitSetOriginItemList } from './actions/zenit.actions';
import { ZenitAnalyticsState, zenitInitialState } from './zenit.state';

export const zenitReducer = createReducer(
    zenitInitialState,

    on(ZenitSetOriginItemList, (state: ZenitAnalyticsState, {
        originItemEventFrom,
        originItemListIndex,
        originItemListName,
        originItemRelatedType,
    }) => {
        return {
            ...state,
            originItemEventFrom,
            originItemListIndex,
            originItemListName,
            originItemRelatedType,
        };
    }),
);
